/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'

import styles from './styles.module.css'

const FilterIcon = () => (
  <div className={styles.filterIconWrapper}>
    <svg
      stroke='currentColor'
      fill='currentColor'
      strokeWidth='0'
      className={styles.filterIcon}
      viewBox='0 0 32 32'
      height='28px'
      width='28px'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M12 16V6H14V10L28 10V12L14 12V16H12Z'></path>
      <path d='M10 10L4 10V12L10 12V10Z'></path>
      <path d='M20 26V16H22V20H28V22H22V26H20Z'></path>
      <path d='M18 20L4 20V22H18V20Z'></path>
    </svg>
  </div>
)

const FilterAmount = ({ count }) => (
  <div className={styles.filterAmount} data-value={count} data-small={count.toString().length === 1}></div>
)

const FloatingFilterButton = ({ onClick, filtersCount = 0, isCollapsed = false, isHidden = false, ...props }) => (
  <div {...props} className={styles.modalTrigger}>
    <div className={styles.wrapper} data-open={!isCollapsed} data-hidden={isHidden}>
      <button className={styles.button} onClick={onClick}>
        <span className={styles.label}>Filter & Sort</span>

        <FilterIcon />

        <FilterAmount count={filtersCount} />
      </button>
    </div>
  </div>
)

export default FloatingFilterButton
